import React, { useEffect, useState } from "react";
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, Button, ModalBody, Modal } from "reactstrap";
import TuneIcon from '@mui/icons-material/Tune';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { Autocomplete, Checkbox } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ReplayIcon from '@mui/icons-material/Replay';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Input as BaseInput } from '@mui/base/Input';
import { createIgm, fetchInvoiceForIgm, getSASToBlob } from "../../../api/po";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { StorePageHeaderName } from "../../../store/pageHeader/action";
import { useDispatch } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";
import Grid from '@mui/material/Grid';

const blue = {
    100: '#DAECFF',
    200: '#b6daff',
    400: '#3399FF',
    500: '#007FFF',
    600: '#0072E5',
    900: '#003A75',
};

const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
};

const InputElement = styled('input')(
    ({ theme }) => `
    width: 120px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 4px;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    box-shadow: 0px 2px 4px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
        };
  
    &:hover {
      border-color: ${blue[400]};
    }
  
    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
    }
  
    // firefox
    &:focus-visible {
      outline: 0;
    }
  `,
);
const IGM = () => {


    const dispatch = useDispatch();
    dispatch(StorePageHeaderName('IGM'))

    const [showList, setShowList] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [invoiceList, setInvoiceList] = useState([]);
    const [fullHistoryData, setFullHistoryData] = useState([]);
    const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);

    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [selectedBlNumber, setSelectedBlNumber] = useState('');
    const [selectedBlDate, setSelectedBlDate] = useState('');
    const [file, setFile] = useState('');

    const [igmNoSet, setIgmNoSet] = useState(null);
    const [options, setOptions] = useState(
        {
                igm_number: '',
                igm_number_error: '',
                igm_date: '',
                igm_date_error: '',
                conversion_rate: '',
                conversion_rate_error: '',
                detention_date: '',
                detention_date_error: '',
        }
    );
    const [message, setMessage] = useState('IGM was submitted successfully');

    const [isSubmitModalOpen, setSubmitModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [payload, setPayload] = useState(null);

    const handleInputChange = (value, input_name) => {
        let prev = {...options};
        prev[input_name] = value;
        setOptions(prev);
    }

    const handleSubmit = async () => {
        try {
            let hasError = false;
            let newOptions = {...options};

            if(!newOptions.igm_number){
                newOptions.igm_number_error = 'IGM number is required!';
                hasError = true;
            } else if(igmNoSet && igmNoSet.has(newOptions.igm_number)){
                newOptions.igm_number_error = 'IGM number already exists!';
                hasError = true;
            }

            if(!newOptions.igm_date){
                newOptions.igm_date_error = 'IGM date is required!';
                hasError = true;
            }

            if(!newOptions.detention_date){
                newOptions.detention_date_error = 'Detention date is required!';
                hasError = true;
            }

            if(!newOptions.conversion_rate){
                newOptions.conversion_rate_error = 'Exchange rate is required!';
                hasError = true;
            }

            if(hasError){
                setOptions(newOptions);
                return;
            }


            /*

            invoice_id: bigint;
            igm_no: string;
            igm_date: Date;
            conversion_rate: number;
            detention_date: Date;

            */
            const data = {
                invoice_id: selectedInvoice.id,
                igm_no: options.igm_number,
                igm_date: dayjs(options.igm_date).format('YYYY-MM-DD'),
                conversion_rate: options.conversion_rate,
                detention_date: dayjs(options.detention_date).format('YYYY-MM-DD'),
            }


            setPayload(data);
            setSubmitModalOpen(true);

            


        } catch (error) {
            toast.error("Error in submitting invoice data");
            console.log(error);
        }
    }

    const submitRequisition = async () => {

        try{
         setIsLoading(true);

         if (file) {
            const response =  await getSASToBlob({uploadType:'IGM'})
 
            const fetchOptions = {
                method: 'PUT',
                body: file,
                headers: {
                    'x-ms-blob-type': 'BlockBlob',
                    'Content-Type': file.type 
                },
            }
             if(response.statusCode===200 && response.data.preSignedUrl){
                
                 try {
                     const res = await fetch(response.data.preSignedUrl, fetchOptions);
         
                     if (res.ok) {
                        payload.blob_name = response.data.blobName
                        payload.file_name = file.name
                     }
                 } catch (error) {
                     console.error('Error uploading file:', error);
                     toast.error('Error uploading file')
                     return
                 }
                 
             }
         }
 
         const response = await createIgm(payload);
            if(response.statusCode == 200){
                setMessage(`IGM was submitted successfully with IGM no: ${response.data.igmDetails.igm_no}`);
                setSubmitModalOpen(false);
                setIsOpenSweetAlert(true);
                setSelectedInvoice(null);
                setPayload(null);
                fetchInvoiceForIgmFromBackend();
            }
 
 
         } catch (error) {
             toast.error("Error in submitting invoice data");
             console.log(error);
         } finally {
             setIsLoading(false);
         }
     };

     const onFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleButtonClick = () => {
        setModalIsOpen(true);
    };
    const closeModal = () => {
        setModalIsOpen(false);
    };
    const toggleList = () => {
        setShowList(!showList);
    };
    const Input = React.forwardRef(function CustomInput(props, ref) {
        return <BaseInput slots={{ input: InputElement }} {...props} ref={ref} />;
    });
    document.title = "Dashboard | Procurement Dashboard";
    const productList = [
        { label: 'PO123844' },
        { label: 'PO654344' },
        { label: 'PO128448' },
        { label: 'PO342344' },
        { label: 'PO652344' },]

    const top100Films = [
        { label: '30% 30 Days' },
        { label: '30% 60 Days' },
        { label: 'No  60 Days' },
        { label: '30% 45 Days' },
        { label: '30% 15 Days' },]

        const columns = [
            {
                field: 'Sl_No', headerName: 'Sl.No', flex: .5,
                resizable: false,
                sortable: false,
            },
            // {
            //     field: 'Invoice_no',
            //     headerName: 'Invoice No',
            //     headerClassName: 'break-header',
            //     cellClassName: 'product_name_wrap',
            //     width: 160,
            //     editable: false,
            //     resizable: false,
            //     sortable: false,
            //     flex: 1,
            // },
            {
                field: 'Bl_no',
                headerName: 'BL No',
                headerClassName: 'break-header',
                cellClassName: 'product_name_wrap',
                width: 160,
                editable: false,
                resizable: false,
                sortable: false,
                flex: 1,
            },
            {
                field: 'Bl_date',
                headerName: 'BL Date',
                headerClassName: 'table-header-background',
                // width: 160,
                editable: false,
                resizable: false,
                sortable: false,
                flex: 1,
            },
            {
                field: 'IGM_no',
                headerName: 'IGM No',
                headerClassName: 'table-header-background',
                // width: 160,
                editable: false,
                resizable: false,
                sortable: false,
                flex: 1,
            },
            {
                field: 'IGM_date',
                headerName: 'IGM Date',
                headerClassName: 'table-header-background',
                // width: 160,
                editable: false,
                resizable: false,
                sortable: false,
                flex: 1,
            },
            {
                field: 'conversion_rate',
                headerName: 'Conversion Rate',
                headerClassName: 'table-header-background',
                sortable: false,
                resizable: false,
                // width: 160,
                headerAlign: 'center',
                cellClassName: 'center-aligndata',
                flex: 1,
            },
            {
                field: 'Detention_date',
                headerName: 'Detention Date',
                headerClassName: 'break-header',
                sortable: false,
                resizable: false,
                // width: 160,
                headerAlign: 'center',
                cellClassName: 'center-aligndata',
                flex: 1,
            },
        ];

    const [inputValue, setInputValue] = useState('');
    const [selectedValue, setSelectedValue] = useState(null);

    const fetchInvoiceForIgmFromBackend = async () => {
        try {

          const response = await fetchInvoiceForIgm();
            
          let formattedInvoices = response.data.InvoiceOptions.map(el => ({
            id: el.id,
            erp_po_id: el.erp_po_id,
            invoice_no: el.invoice_number,
            label: el.invoice_number,
            port_no: el.port_name,
            bl_no: el.bl_no,
            bl_date: el.bl_date
          }));

          setInvoiceList(formattedInvoices);

          let formattedIGM = response.data.InvoiceHistory.map(el => {
            let mappedItems = el.procurementIGM.map(item => ({
                ...item,
                invoice_no: el.invoice_number,
                bl_no: el.bl_no,
                bl_date:el.bl_date
            }));

            return mappedItems;
          }).flat();


          addInvoiceIGMRows(formattedIGM);

          let arr = formattedIGM.map(el => el.igm_no);

          setIgmNoSet(new Set(arr));

        } catch (error) {
          toast.error("Error in fetching invoice data");
          console.log(error);
        }
    };

    const addInvoiceIGMRows = (result) => {
        if (result.length > 0) {
            const formattedProducts = result.map((product, index) => ({
                id: index, // Assuming index + 1 as ID
                Sl_No: index + 1, // Serial Number
                Invoice_no: product.invoice_no,
                Bl_no: product.bl_no,
                Bl_date:dayjs(product.bl_date).format('YYYY-MM-DD'),
                IGM_no: product.igm_no,
                IGM_date: dayjs(product.igm_date).format('YYYY-MM-DD'),
                conversion_rate: product.conversion_rate,
                Detention_date: dayjs(product.detention_date).format('YYYY-MM-DD')
            }));
            setFullHistoryData(formattedProducts);
        }
      }



      useEffect(() => {
        fetchInvoiceForIgmFromBackend();
      }, [])

      useEffect(() => {
        setOptions({
            igm_number: '',
            igm_number_error: '',
            igm_date: '',
            igm_date_error: '',
            conversion_rate: '',
            conversion_rate_error: '',
            detention_date: '',
            detention_date_error: '',
        });
        setSelectedBlNumber('');
        setSelectedBlDate('');
        setFile('')
        if(selectedInvoice){
            setOptions(prev => ({...prev, conversion_rate: 1}));
            setSelectedBlNumber(selectedInvoice.bl_no);
            setSelectedBlDate(selectedInvoice.bl_date);
        }
      }, [selectedInvoice, invoiceList]);

      const handleSweetAlertConfirm = () => {
        setIsOpenSweetAlert(false);
    };


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div>
                        <Card>
                            <CardBody>
                                <div>
                                    <div className='d-flex align-items-center  justify-content-between mb-2 gap-2'>
                                        <div className="d-flex align-items-center gap-2">
                                            <p className='mb-0 me-2 requisition_type_text'>IGM </p>
                                            <div>
                                            <Autocomplete
                                                className="invoice_autofield"
                                                // id={`product-category`}
                                                sx={{ width: 230 }}
                                                options={invoiceList}
                                                onChange={(e, value) => {
                                                    setSelectedInvoice(value);
                                                }}
                                                value={selectedInvoice}
                                                // onChange={handleProductCategoryChange}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Select Invoice No"
                                                    />
                                                )}
                                            />

                                        </div>
                                            </div>
                                        <div className="d-flex align-items-center mt-2 justify-content-end">
                                            <button className="assign_vendor" onClick={handleSubmit}>Submit</button>
                                        </div>
                                        {/* <div className="d-flex align-items-center">
                                            <button className="assign_vendor" onClick={handleSubmit}>Submit</button>
                                        </div> */}
                                    </div>
                                    <div className='d-flex align-items-center mb-2 gap-2 flex-wrap mt-3'>
                                    <Grid container item xs={12} sm={12} spacing={1}>
                                    <Grid item xs={2}>
                                        {/* <div> */}
                                            <TextField
                                                className="create_requisition_textfield"
                                                // id={`quantity-${index}`}
                                                label="BL No"
                                                variant="outlined"
                                                value={selectedBlNumber}
                                                disabled
                                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                                // sx={{ width: 230 }}
                                                sx={{ width: '100%'}}
                                            />
                                        {/* </div> */}
                                        </Grid>
                                        <Grid item xs={2}>
                                        {/* <div> */}
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    className='payment_date date_picker_fullwidth'
                                                    label="Bl Date"
                                                    disablePast
                                                    value={dayjs(selectedBlDate)}
                                                    disabled
                                                //   onChange={handleDateChange}
                                                />
                                            </LocalizationProvider>
                                        {/* </div> */}
                                        </Grid>
                                        <Grid item xs={2}>
                                        {/* <div> */}
                                            <TextField
                                                className="create_requisition_textfield"
                                                // id={`quantity-${index}`}
                                                label="IGM No"
                                                variant="outlined"
                                                value={options.igm_number}
                                                onChange={(event) => handleInputChange(event.target.value, 'igm_number')}
                                                // sx={{ width: 230 }}
                                                sx={{ width: '100%'}}
                                            />

                                            {options.igm_number_error && <span className="error-message" style={{ color: 'red' }}>{options.igm_number_error}</span>}

                                        {/* </div> */}
                                        </Grid>
                                        <Grid item xs={2}>
                                        {/* <div> */}
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    className='payment_date date_picker_fullwidth'
                                                    sx={{ width: 220 }}
                                                    // width="190px"
                                                    label="IGM Date"
                                                    disablePast
                                                  value={dayjs(options.igm_date)}
                                                  onChange={(event) => handleInputChange(event, 'igm_date')}
                                                />
                                            </LocalizationProvider>
                                            {options.igm_date_error && <span className="error-message" style={{ color: 'red' }}>{options.igm_date_error}</span>}
                                        {/* </div> */}
                                        </Grid>
                                        <Grid item xs={2}>
                                        {/* <div> */}
                                            <TextField
                                                className="create_requisition_textfield"
                                                // id={`quantity-${index}`}
                                                label="Conversion Rate"
                                                variant="outlined"
                                                value={options.conversion_rate}
                                                type='number'
                                                onChange={(event) => {
                                                    if(event.target.value >= 0 && event.target.value < 999999999){

                                                    handleInputChange(event.target.value, 'conversion_rate')
                                                    }
                                                }}
                                                // sx={{ width: 220,}}
                                                sx={{ width: '100%'}}
                                            />
                                            {options.conversion_rate_error && <span className="error-message" style={{ color: 'red' }}>{options.conversion_rate_error}</span>}

                                        {/* </div> */}
                                        </Grid>
                                        <Grid item xs={2}>
                                        {/* <div> */}
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    className='payment_date date_picker_fullwidth'
                                                    label="Detention Date"
                                                    disablePast

                                                    value={dayjs(options.detention_date)}
                                                    onChange={(event) => handleInputChange(event, 'detention_date')}
                                                />
                                            </LocalizationProvider>
                                            {options.detention_date_error && <span className="error-message" style={{ color: 'red' }}>{options.detention_date_error}</span>}
                                        {/* </div> */}
                                        </Grid>
                                        <Grid item xs={2}>
                                        {/* <div className='d-flex align-items-center gap-2'>
                                            <p className="mb-0">IGM Upload</p>
                                            <div className="upload-btn-wrapper ms-2">
                                                <button className="btn">Upload</button>
                                                <input type="file" name="myfile" onChange={(e) => onFileChange(e)} />
                                                {file && <p className="mb-0" style={{ color: "#0060AA" }}>{file.name}</p>}

                                            </div>
                                        </div> */}
                                        </Grid>
                                    </Grid>
                                    </div>
                                    {/* <div className="d-flex align-items-center mt-2 justify-content-end">
                                            <button className="assign_vendor" onClick={handleSubmit}>Submit</button>
                                        </div> */}
                                </div>
                            </CardBody>
                        </Card>
                        <div>
                            <div>
                                <h4 className="mb-0 requisition_text">IGM List</h4>
                            </div>
                            <Box sx={{ height: '100%', width: '100%', marginBottom: '1.5rem', marginTop: '10px' }}>
                                <DataGrid
                                    autoHeight
                                    className="table_header_background"
                                    headerClassName="custom-header-cell"
                                    getRowHeight={() => 'auto'}
                                    rows={fullHistoryData}
                                    columns={columns}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 5,
                                            },
                                        },
                                    }}
                                    pageSizeOptions={[5]}
                                    disableRowSelectionOnClick
                                    disableColumnMenu
                                    disableColumnResize={true}
                                    componentsProps={{
                                        cell: {
                                            disableClick: true,
                                        },
                                    }}
                                    sx={{
                                        '& .MuiDataGrid-cell': {
                                            '& .MuiDataGrid-cell--textOverflow': {
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                            },
                                        },
                                    }}
                                />
                            </Box>
                        </div>
                    </div>
                </Container>
            </div>
            <Modal
                isOpen={isSubmitModalOpen}
                onRequestClose={() => setSubmitModalOpen(false)}
                contentLabel="Example Modal"
                className="change_modalbox generatePo_modal"
            >
                <div className='d-flex justify-content-between me-2 mt-3'>
                    <h4 className='ms-3'>Do you want to create this IGM?</h4>
                    <div className='d-flex justify-content-end me-3 modal_close'>
                        <i class="ri-close-line" onClick={() => setSubmitModalOpen(false)}></i>
                    </div>
                </div>
                {/* <hr className='mb-2 mt-1 ms-3 me-3'></hr> */}
                <ModalBody className='pt-2'>
                    <div>
                    <table id="table" className='requisition_balance'>
                                    <thead className='booked_balance_listHeader'>
                                        <tr>
                                            <th>IGM Number</th>
                                            <th>IGM Date</th>
                                            <th>Exchange Rate</th>
                                            <th>Detention Date</th>
                                        </tr>
                                    </thead>
             

                                    <tbody className='requisition_balance_table_body'>
                                        
                                            <tr>
                                                <td>{payload?.igm_no}</td>
                                                <td>{payload?.igm_date}</td>
                                                <td>{payload?.conversion_rate}</td>
                                                <td>{payload?.detention_date}</td>
                                            </tr>
                                        
                                    </tbody>
                                    {/* <tfoot className='requisition_balance_footer'>
                                        <tr>
                                            <th id="total" colSpan="3">Total :</th>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.total_qty;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.received_qty;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.unit_price;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + (currentObject.unit_price * currentObject.received_qty * payload.conversion_rate);
                                                }, 0)}</td>
                                        </tr>
                                    </tfoot> */}
                                </table>
                    </div>
                    <hr className='mb-2 mt-1 ms-3 me-3'></hr>
                    <div className='d-flex align-items-center mt-4 justify-content-center'>
                        <button className="yes_button d-flex align-items-center" disabled={isLoading} onClick={submitRequisition}>
                            Yes
                        </button>
                        <button className="no_button d-flex align-items-center ms-3" onClick={() => setSubmitModalOpen(false)}>
                            No
                        </button>
                    </div>
                </ModalBody>
            </Modal>
            <SweetAlert
                show={isOpenSweetAlert}
                title={message}
                success
                confirmButtonText="Ok"
                confirmBtnBsStyle="success"
                onConfirm={handleSweetAlertConfirm} // Updated to handleSweetAlertConfirm function

            />
        </React.Fragment>
    );
};

export default IGM;
